import React, { useState } from 'react'

interface AgentExamplesProps {
  handleSubmit: (example: string) => Promise<void>
  examples: string[]
  toggleLabel?: string
  className?: string
}

export const AgentExamples: React.FC<AgentExamplesProps> = ({ handleSubmit, examples, toggleLabel, className }) => {
  const [showExamples, setShowExamples] = useState<boolean>(true)

  const handleToggleExamples = () => {
    setShowExamples(!showExamples)
  }

  const handleExampleSelected = async (example: string) => {
    setShowExamples(false)
    await handleSubmit(example)
  }

  return (
    <>
      <div className={`d-flex flex-column gap-2 ${className ?? ''}`}>
        <div className='d-flex gap-2 cursor-pointer align-self-start' onClick={handleToggleExamples}>
          <span className='lead-small'>{toggleLabel ?? 'TRY SEARCHING'}</span>
          {showExamples ? <i className='bi bi-chevron-down' /> : <i className='bi bi-chevron-right' />}
        </div>
        {showExamples ? (
          <div className='d-flex flex-wrap gap-2 align-items-start'>
            {examples.map((e, index) => (
              <div key={index} className='zocks-py-0.125 px-2 ai-agent-example rounded-5 mw-0 cursor-pointer' onClick={() => handleExampleSelected(e)}>
                <span className='paragraph-medium'>{e}</span>
              </div>
            ))}
          </div>
        ) : null}
      </div>
    </>
  )
}
